// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import {getCookie}  from './until/until';
// import $api from './axios/api';
// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: 'small'
});
Vue.prototype.$axios = axios;
// Vue.prototype.$api = $api;

//使用钩子函数对路由进行权限跳转

router.beforeEach((to, from, next) => {
  let session =getCookie("doctorId");
  if(to.path == '/docDownloadAll'){
    session = 'down';
    next();
    return ;
  }
  if(session=='null'||session==''||session==undefined||session==null){
    if(to.path=='/Login'){
      next();
    }else{
      next({
        path: '/Login'
      });
    }
  }else{
    if(session == 'down'){
      next();
    }else if(to.path.toString()==('/')){
      next({
        path: '/'
      });
    }else{
      if(to.path.toString()==('/login')){
        next({
          path: '/'
        });
      }else{
        next();
      }
    }

  }

});
router.afterEach((to,from,next) => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = document.body.scrollTop = 0;
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js